import { ShareNowIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import type { IconComponent } from '@change-corgi/design-system-legacy/icons';
import { iconEmail, iconFacebook, iconTwitter } from '@change-corgi/design-system-legacy/icons';
import { buttonResetStyles } from '@change-corgi/design-system-legacy/reset';
import type { ColorName } from '@change-corgi/design-system-legacy/theme';

import type { Channel } from './hooks/useShareLinks';
import { useShareLinks } from './hooks/useShareLinks';

const ICON_MAP: Record<Channel, IconComponent> = {
	twitter: iconTwitter,
	facebook: iconFacebook,
	email: iconEmail,
};
const ICON_COLOR_MAP: Record<Channel, ColorName> = {
	twitter: 'social-twitter',
	facebook: 'social-facebook',
	email: 'social-email',
};

export function ShareLinks() {
	const {
		data: { shareActions },
	} = useShareLinks();

	return (
		<div className="flex items-center gap-4">
			<Text className="text-typography-weak hidden uppercase md:block" size="small">
				<Translate value="fe.components.news_header.share" />
			</Text>
			<Text className="text-typography-weak block flex items-center uppercase md:hidden" size="small">
				<Text className="sr-only" size="small">
					<Translate value="fe.components.news_header.share" />
				</Text>
				<ShareNowIcon size="medium" />
			</Text>

			{shareActions.map(({ channel, action }) => (
				<button
					key={channel}
					data-testid={`news-share-${channel}`}
					type="button"
					sx={{ ...buttonResetStyles, height: 28 }}
					onClick={action}
					data-qa={`news-share-${channel}`}
				>
					{
						// TODO: replace this social sharing icons once the new SocialSharingIcon component is available in the design system
					}
					<Icon icon={ICON_MAP[channel]} size="xxl" color={ICON_COLOR_MAP[channel]} />
					{/* TODO this should be a i18n string, at least for email */}
					<Text className="sr-only" size="small">
						{channel}
					</Text>
				</button>
			))}
		</div>
	);
}
